import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { WwwAppState } from '@pro-connect/shared';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AppStateModel {
  test: string | null;
}

@State<AppStateModel>({
  name: 'wwwApp',
  defaults: {
    test: null,
  },
})
@Injectable()
export class AppState extends WwwAppState {}
